import useStyles from './Content.styled'

export const useContent = props => {
	const {
		image,
		mobileAlignment,
		text,
		textConfig,
		rounding,
		onTextClick,
		onImageClick,
		extraShortcuts,
		textEditable,
		onTextChange,
		textKey,
		onClick,
	} = props

	const { classes, cx } = useStyles(props, { props })

	return [
		{
			classes,
			cx,
			mobileAlignment,
			image,
			text,
			textConfig,
			rounding,
			extraShortcuts,
			contentClasses: {
				root: cx(classes.content, props.classes.content),
				image: cx(classes.image, props.classes.image),
			},
			textEditable,
			textKey,
		},
		{
			handleTextClick: onTextClick,
			handleImageClick: onImageClick,
			handleTextChange: onTextChange,
			handleClick: onClick,
		},
	]
}
